<template>
  <div>
    <img src="https://images.snsports.cn/FkfEefQ1FmEyfW90bNSBnmqVbD2v" />
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/service-contact/index.vue